const userModule = {
    namespaced: true,
    state: {
      userId: null,
      userName: null,
      userType: null,
    },
    mutations: {
      SET_USERID(state, payload) {
        state.userId = payload
      },
      SET_USERTYPE(state, payload) {
          state.userType = payload
      },
      SET_USERNAME(state, payload) {
        state.userName = payload
    },
    },
    actions: {
      setUserId: ({ commit, state }, payload) => {
        commit('SET_USERID', payload)
      },
      setUserType: ({ commit, state }, payload) => {
          commit('SET_USERTYPE', payload)
      },
      setUserName: ({ commit, state }, payload) => {
        commit('SET_USERNAME', payload)
    }
    },
    getters: {
      getUserId: state => {
        return state.userId
      },
      getUserType: state => {
        return state.userType
      },
      getUserName: state => {
        return state.userName
      }
    },
    // plugins: [vuexPersist.plugin]
}

export default userModule